import { Editor } from '@tiptap/core';
import { IMAGE_EXTENSION_NAME } from '../extensions/ImagePickerExtension';

export const findExtensionByName = (editor: Editor, name: string) =>
  editor.options.extensions.find(ext => ext.name === name);

export const hasExtensionEnabled = (editor: Editor, name: string) => {
  return editor.options.extensions.some(ext => ext.name === name);
};

/**
 * The image node is registered in every editor so existing images survive a
 * parse/serialise round-trip, but only an editor given a picker can insert one.
 */
export const hasToolbarItemEnabled = (editor: Editor, name: string) => {
  if (name !== IMAGE_EXTENSION_NAME) return hasExtensionEnabled(editor, name);
  return Boolean(findExtensionByName(editor, name)?.options.imagePicker);
};
